import { createReducer, on } from '@ngrx/store';
import * as slmDetailsActions from '@Actions/slmDetails.actions';
import { MuseumDetails } from '@Interfaces/dddApi.interfaces';

const slmMuseumDetailsInitialState: { [codesr: string]: MuseumDetails } = {};

export const slmDetailsReducer = createReducer(
  slmMuseumDetailsInitialState,
  on(slmDetailsActions.setSingleMuseumDetails, (state, { museumDetails }) => {
    return { ...state, [museumDetails.id]: museumDetails };
  }),
  on(
    slmDetailsActions.setMultipleMuseumDetails,
    (state, { museumsDetails }) => {
      return {
        ...state,
        ...museumsDetails
      };
    }
  ),
  on(slmDetailsActions.clearSlimMuseumDetails, (state) => {
    return slmMuseumDetailsInitialState
  })
);
